import script from "./InovahcSpecialtiesView.vue?vue&type=script&setup=true&lang=js"
export * from "./InovahcSpecialtiesView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__